module.exports = __webpack_public_path__ + "img/tags.507fcbfb.svg";